import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class BetsOverview extends Component {
  render() {
    return (
      <div className="text-center">
        <FontAwesomeIcon icon="circle-notch" size="2x" spin />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ScreenLoader/ScreenLoader.js